import {
  Button,
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead,
  SPACING_32,
  SpacingVertical
} from 'mailup-web-components'
import {
  modalSharedListsCancelCallback,
  modalSharedListsConfirmCallback
} from 'Pages/SourcesList/recoil/callbacks/callbacks'
import {
  modalSharedListsState,
  modalSharedListsValidState
} from 'Pages/SourcesList/recoil/state/modals'

import { useIntl } from 'react-intl'

import { useRecoilCallback, useRecoilValue } from 'recoil'

import InputLists from './InputLists'

const ModalSharedLists = () => {
  const intl = useIntl()

  const { show } = useRecoilValue(modalSharedListsState)
  const validForm = useRecoilValue(modalSharedListsValidState)

  const handleClose = useRecoilCallback(modalSharedListsCancelCallback)
  const handleConfirm = useRecoilCallback(modalSharedListsConfirmCallback, [])

  return (
    <Modal show={show} showClose onClose={handleClose}>
      <ModalHead
        title={intl.formatMessage({
          id: 'Load.ContentsSouces.SharedModalTitle'
        })}
      />
      <ModalBody>
        <>
          {intl.formatMessage({
            id: 'Load.ContentsSouces.SharedModalDescr'
          })}
          <SpacingVertical variant={SPACING_32} />
        </>
        <InputLists />
      </ModalBody>
      <ModalFoot>
        <Button onClick={handleClose} kind='secondary'>
          {intl.formatMessage({ id: 'Load.MailupCommon.Cancel' })}
        </Button>
        <Button onClick={handleConfirm} kind='primary' disabled={!validForm}>
          {intl.formatMessage({ id: 'Load.MailupCommon.Save' })}
        </Button>
      </ModalFoot>
    </Modal>
  )
}

export default ModalSharedLists
